// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1J9HB","label":"Section_label__2mPrc","contentWrap":"Section_contentWrap__3tj7n","footer":"Section_footer__36Wgx","footerInner":"Section_footerInner__3PMGs"};